export default __webpack_public_path__ + "static/media/AdministracionWhite.40fedd79.svg";